import { render, staticRenderFns } from "./admin-faculties.vue?vue&type=template&id=df4f7d80&scoped=true"
import script from "./admin-faculties.vue?vue&type=script&lang=js"
export * from "./admin-faculties.vue?vue&type=script&lang=js"
import style0 from "./admin-faculties.vue?vue&type=style&index=0&id=df4f7d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4f7d80",
  null
  
)

export default component.exports